import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    ref: "outer-container",
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('h5', [_vm._v("\n    " + _vm._s(_vm.headline || _vm.$i18n_t('DigitalTwin.VirtualDevice.details.packethistory')) + "\n    "), _vm.isLiveViewer ? [_vm._v("\n      " + _vm._s(_vm.headline ? '' : '&') + "\n      " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.details.packethistoryliveviewer')) + "\n    ")] : _vm._e()], 2), !_vm.dataIsLoading || _vm.packetHistory.length > 0 ? _c(VCard, {
    ref: "outer-card",
    staticClass: "dt-card-text-01 outer-card",
    attrs: {
      "height": _vm.height
    }
  }, [_c('div', {
    ref: "top-element"
  }), _vm.loadingError === 'TIMEOUT' ? [_c('div', {
    staticClass: "empty-state",
    staticStyle: {
      "width": "60%",
      "margin": "0 auto"
    }
  }, [_c(VIcon, {
    staticClass: "mr-2",
    attrs: {
      "medium": ""
    }
  }, [_vm._v("fal fa-exclamation-triangle")]), _vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.details.packetTimeout')) + "\n      ")], 1)] : _vm.hasNoPackets ? [_c('div', {
    staticClass: "empty-state"
  }, [_c(VIcon, {
    staticClass: "mr-2",
    attrs: {
      "medium": ""
    }
  }, [_vm._v("fal fa-comment-exclamation")]), _vm._v("\n        " + _vm._s(_vm.noPacketLabel || _vm.$i18n_t('DigitalTwin.VirtualDevice.details.noPacketData')) + "\n      ")], 1)] : _vm.bridgeManifest === null || _vm.get(_vm.bridgeManifest, 'virtualDevice.deviceTypes.packetParser') ? [_c('table', {
    staticClass: "packet-history-list",
    attrs: {
      "data-cy": "packet_history_table"
    }
  }, [_vm._t("tableHeader"), _vm._l(_vm.packetHistory, function (item, i) {
    return _c('tr', {
      key: `${item.timestamp}_${i}`,
      staticClass: "clickable",
      attrs: {
        "data-cy": "packet_history_row"
      },
      on: {
        "click": function ($event) {
          return _vm.clickRowHandler(item);
        }
      }
    }, [_c('td', {
      style: `color: ${_vm.customColor};`
    }, [_vm._v("↑")]), _c('td', [_c('span', {
      staticStyle: {
        "white-space": "nowrap"
      }
    }, [_vm._v(_vm._s(_vm.localizeDate(item.time)))])]), _vm.get(_vm.bridgeManifest, 'virtualDevice.deviceTypes.packetParser.valueMapping.frameCounter') ? _c('td', [_vm._v("\n            " + _vm._s(_vm.get(item, `value.${_vm.bridgeManifest.virtualDevice.deviceTypes.packetParser.valueMapping.frameCounter}`)) + "\n          ")]) : _vm._e(), _c('td', {
      attrs: {
        "data-cy": "payload_cell"
      }
    }, [_c('custom-copy-clipboard', {
      staticClass: "copy-red",
      staticStyle: {
        "max-width": "250px"
      },
      attrs: {
        "small": "",
        "content": _vm.get(item, _vm.valuePath, _vm.$i18n_t('DigitalTwin.VirtualDevice.details.emptyPayload'))
      }
    })], 1), item.externalId ? _c('td', {
      attrs: {
        "data-cy": "identifier_cell"
      }
    }, [_c('router-link', {
      attrs: {
        "to": `/virtual-devices/${item.id}`
      }
    }, [_c('code', [_vm._v(_vm._s(item.externalId))])])], 1) : _vm._e(), _vm.get(_vm.bridgeManifest, 'virtualDevice.deviceTypes.packetParser.valueMapping.port') ? _c('td', [_vm.get(item, `value.${_vm.bridgeManifest.virtualDevice.deviceTypes.packetParser.valueMapping.port}`) ? _c('span', [_vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.parser.port')) + "\n              " + _vm._s(_vm.get(item, `value.${_vm.bridgeManifest.virtualDevice.deviceTypes.packetParser.valueMapping.port}`)) + "\n            ")]) : _vm._e()]) : _vm._e(), _vm.get(_vm.bridgeManifest, 'virtualDevice.metaData') ? _vm._l(_vm.bridgeManifest.virtualDevice.metaData, function (metaDataCol, j) {
      return _c('td', {
        key: `${item.timestamp}_${i}_metadata_${j}`
      }, [Number.isFinite(_vm.get(item, `value.${metaDataCol.path}`)) ? [_vm._v("\n                " + _vm._s(metaDataCol.name) + " " + _vm._s(_vm.get(item, `value.${metaDataCol.path}`)) + "\n              ")] : _vm._e()], 2);
    }) : _vm._e()], 2);
  }), _vm.showLoadMore ? _c('tr', [_c('td', {
    staticStyle: {
      "background": "transparent !important"
    },
    attrs: {
      "colspan": _vm.colNumber,
      "align": "center"
    }
  }, [_c(VBtn, {
    ref: "load_more_btn",
    class: `v-btn-x v-btn--rounded bg-rounded-button-${_vm.color}`,
    attrs: {
      "color": _vm.color,
      "rounded": "",
      "text": "",
      "data-cy": "load_more_btn"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('loadData', true);
      }
    }
  }, [_c(VIcon, {
    staticClass: "mr-2",
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fal fa-arrow-down")]), _vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.loadMore')) + "\n            ")], 1)], 1)]) : _vm._e()], 2)] : _vm._e()], 2) : _c(VCard, {
    ref: "outer-card",
    staticClass: "dt-card-text-01 outer-card",
    attrs: {
      "height": _vm.height,
      "align": "middle"
    }
  }, [_c(VProgressCircular, {
    staticStyle: {
      "margin-top": "150px"
    },
    attrs: {
      "color": _vm.color,
      "width": "2",
      "indeterminate": ""
    }
  }), _c('br'), _c('p', {
    staticClass: "mt-4",
    attrs: {
      "color": _vm.color
    }
  }, [_vm._v(_vm._s(_vm.$i18n_t('Common.loading')))])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };